'use client';
// TODO: Возможно вынести как утилиту. Аналогичная функциональность есть в пакете @s7/figma, но работает со всеми видами пробелов;
const removeNonBreakingSpaces = (text)=>{
    return text.replace(/&nbsp;/g, '');
};

export { removeNonBreakingSpaces };
//# sourceMappingURL=removeNonBreakingSpaces.js.map
